/*global Modul */
define(
    "diy/undo-redo/executor/Server",
    [
        'jquery',
        'diy/site-admin/main/api',
        'diy/undo-redo/executor/Base',
        'diy/undo-redo/ExecutedEntry',
        'diy/undo-redo/constants'
    ],
    /**
     * @param {jQuery|{Function()::jQuery}} $
     * @param {{destroyController: Function()}} siteadminApi
     * @param {module.undoRedo.Executor.Base} Base
     * @param {module.undoRedo.ExecutedEntry} ExecutedEntry
     * @param {module.undoRedo.constants} constants
     * @returns {*}
     */
    function ($, siteadminApi, Base, ExecutedEntry, constants) {
        'use strict';
        var Executor;

        /**
         * @class module.undoRedo.Executor.Server
         * @template module.undoRedo.Executor.Server
         * @lends {module.undoRedo.Executor.Server.prototype}
         * @extends {module.undoRedo.Executor.Base}
         * @constructor
         */
        Executor = Base.extend({

            type: constants.executionType.SERVER,

            /**
             *
             * For server entries ww will execute only the last entry from set (the server will execute the intermediary
             *  entries to keep the chain complete
             *
             * @param {Array.<module.undoRedo.Entry>} items
             * @param {Array.<module.undoRedo.ExecutedEntry>} result
             * @param {Boolean} hasLastEntry
             * @returns {*}
             */
            executeSet: function executeSet(items, result, hasLastEntry) {
                var main = Q.defer(), entryToExecute, executedEntryKey;

                entryToExecute = items[items.length - 1];
                executedEntryKey = entryToExecute.getKey();

                this.backend.executeRemote(executedEntryKey)
                    .then(this.syncHistoryFromServer.bind(this))
                    .then(function (serverResponse) {
                        this.addExecutedEntries(serverResponse, result, (hasLastEntry ? executedEntryKey : null));
                        this.applyExecution(result)
                            .then(function () {
                                main.resolve(result);
                            })
                            .catch(function (error) {
                                main.reject(error);
                            });
                    }.bind(this))
                    .catch(function (error) {
                        main.reject(error);
                    });
                return main.promise;
            },
            /**
             *
             * @param {{history: Object, data: Object, limitations: Object}} serverResponse
             */
            syncHistoryFromServer: function syncHistoryFromServer(serverResponse) {
                return this.history.populateChains(serverResponse.history)
                    .then(function (){
                        this.handleServerSideLimitations(serverResponse.limitations);
                        return Q(serverResponse);
                    }.bind(this));
            },
            /**
             *
             * @param {{history: Object, data: Object}} serverResponse
             * @param {Array.<module.undoRedo.ExecutedEntry>} result
             * @param callToExecutionKey
             */
            addExecutedEntries: function addExecutedEntries(serverResponse, result, callToExecutionKey) {
                serverResponse.data.forEach(function (item, index) {
                    var
                        existingEntry = this.history.getEntryByKey(item.entryId),
                        executedEntry;

                    if (existingEntry !== null) { // } && existingEntry.isSessionHead === false) {
                        executedEntry = new ExecutedEntry();
                        executedEntry.setOnExecuted(existingEntry.onExecuted.bind(existingEntry), item);

                        if (callToExecutionKey === existingEntry.getKey()) {
                            executedEntry.setOnExecutedLast(existingEntry.onExecutedLast.bind(existingEntry));
                        }
                        result.push(executedEntry);
                    }

                }.bind(this));
            },
            /**
             *
             * @param {Array.<module.undoRedo.ExecutedEntry>} items
             */
            applyExecution: function applyExecution(items) {
                var toApply = [];
                items.forEach(function (item) {
                    toApply.push(function seqApply() {
                        return Q(item.callOnExecuted());
                    });
                });

                return toApply.reduce(Q.when, Q(true));
            },

            /**
             *
             * @param {{hasReachedCriticalLimit: boolean, hasReachedMaximumLimit:boolean}} limitations
             */
            handleServerSideLimitations: function handleServerSideLimitations(limitations) {
                Modul.handleLimitationsResponse(limitations);
            }

        });

        return Executor;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/executor/Server.js
 ** module id = 916
 ** module chunks = 0
 **/